export default "__VITE_ASSET__Bf8xpfzm__"